import { render, staticRenderFns } from "./RouterLinkView.vue?vue&type=template&id=c9662b10&scoped=true&"
import script from "./RouterLinkView.vue?vue&type=script&lang=js&"
export * from "./RouterLinkView.vue?vue&type=script&lang=js&"
import style0 from "./RouterLinkView.vue?vue&type=style&index=0&id=c9662b10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9662b10",
  null
  
)

export default component.exports